import { type ChatMessageItem } from '../../components/chat/ChatMessage';
import { type AiResponse } from '../../types/ai';

export type TurnOutcome =
  | {
      kind: 'customer-switched';
      nextSessionId: string;
      session: AiResponse['session'] | null;
      restartedMessage: ChatMessageItem;
    }
  | {
      kind: 'completed';
      verificationUpgraded: boolean;
      brainModel: string | null;
      handoffSessionId: string | null;
      endChat: boolean;
    };

export const resolveTurnOutcome = (
  response: AiResponse,
  {
    sessionId,
    assistantMessage,
    fallbackLanguage,
  }: {
    sessionId: string;
    assistantMessage: ChatMessageItem;
    fallbackLanguage: string;
  },
): TurnOutcome => {
  if (response.customerSwitched) {
    return {
      kind: 'customer-switched',
      nextSessionId: response.sessionId ?? sessionId,
      session: response.session ?? null,
      restartedMessage: {
        id: response.assistantMessageId ?? assistantMessage.id,
        role: 'assistant',
        content: response.message,
        createdAt: assistantMessage.createdAt,
        status: 'success',
        sources: response.sources,
        orderContext: response.orderContext ?? undefined,
        responseMode: response.responseMode,
        suppressOrderContext: response.suppressOrderContext,
        outfitProducts: response.outfitProducts ?? undefined,
        productCards: response.productCards ?? undefined,
        selectedProducts: response.selectedProducts ?? undefined,
        routing: response.routing ?? undefined,
        detectedLanguage: response.detectedLanguage ?? fallbackLanguage,
      },
    };
  }

  return {
    kind: 'completed',
    verificationUpgraded: Boolean(response.verificationUpgradedInPlace),
    brainModel:
      typeof response.brainModel === 'string' && response.brainModel ? response.brainModel : null,
    handoffSessionId: response.shouldContactSupport ? (response.sessionId ?? sessionId) : null,
    endChat: Boolean(response.shouldEndChat),
  };
};
